const RELATIVE_URL_BASE = "http://static-demo.invalid";

export function requestUrl(input: RequestInfo | URL): URL {
  if (input instanceof URL) return input;
  return new URL(typeof input === "string" ? input : input.url, RELATIVE_URL_BASE);
}

export function routePattern(path: string): RegExp {
  const escaped = path.replace(/[.*+?^${}()|[\]\\]/g, "\\$&").replace(/:id/g, "(\\d+)");
  return new RegExp(`^${escaped}$`);
}
